


















































































import { Component } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import AdminService from '@/api/AdminService';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { EBusinessStatus } from '@/models/business';
import DateUtils from '@/utils/DateUtils';
import { getBusinessLocationInfo } from '../../../utils/businessLocationHelper';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    Table,
    RowsTable,
    ContextMenu,
    TextInput,
    CustomSelect,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class AdminOffers extends BasePagination {
  limit = 20;
  service: AdminService = new AdminService();
  businessList: List = new List([], []);
  fidelNullLabel = 'Pending';
  searchableFields = 'searchableFields=business.name';
  sortField = 'business.name';
  sortOrder = 'ASC';
  filterValuesSeparator = ':';

  created() {
    eventBus.$on('reloadBusinessList', () => this.reloadList(true, true));
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get merchantDashboardReportsIsActive() {
    return this.flags.includes(flagKeys.merchantDashboardReports);
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('active', `Active`),
      new CustomSelectOption('inactive', `Inactive`),
      new CustomSelectOption('hiddenOnApp', 'Hidden on App'),
      new CustomSelectOption('visibleOnApp', 'Visible on App')
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by status`,
      false,
      true,
      true,
      false
    );
  }

  getClassNameByBusiness(business: any) {
    if (business.status === EBusinessStatus.hidden) {
      return '--hidden';
    }

    return false;
  }

  getOptionsByData(business: any) {
    const options: ContextMenuOption[] = [];

    return options;
  }

  optionSelected(action: string, props: Array<any>, business: any): void {
    switch (action) {
      default:
        break;
    }
  }

  initHeader() {
    const header = [
      new HeaderList(`Business`, 'none', '12px'),
      new HeaderList(`Business name`, 'business.name'),
      new HeaderList(`Business Location`, 'business.city'),
      new HeaderList(`Status`, 'business.status', '12px'),
      new HeaderList(`Created At`, 'business.createdAt', '12px'),
      new HeaderList(``, 'none', '12px')
    ];
    this.businessList.header = header;
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    notEmpty?: boolean
  ) {
    if (clearList) {
      this.resetPagination();
      if (!notEmpty) this.businessList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;

    this.service
      .getBusinessesList({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.pagination.includes('withOffers')
          ? this.query
          : `${this.query}&withOffers=true`
      })
      .then(response => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;
          this.businessList.list = this.addRowsToList(items);
        } else {
          // refresh page and add items
          this.businessList.list = this.businessList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (this.hasLoadedMore && notEmpty) {
          const listElement = this.$refs.list as HTMLElement;
          listElement.scrollTo(0, 0);
          this.hasLoadedMore = false;
        }

        this.$hideLoader();
        this.isLoading = true;
        this.refreshing = false;
      });
  }

  getStatus(status: string) {
    if (status === 'active' || status === 'launch-campaign-active') {
      return EBusinessStatus.active;
    }

    if (status === 'inactive' || status === 'launch-campaign-inactive') {
      return EBusinessStatus.inactive;
    }

    if (status === 'hidden') {
      return EBusinessStatus.hidden;
    }

    return EBusinessStatus.unknown;
  }

  addRowsToList(businessRows: any[]): any[] {
    return businessRows.map((business: any) => ({
      id: business.id,
      picture: business.logo.publicPath.small,
      name: business.name,
      mail: business.manager.mail,
      managerName: business.manager.fullName,
      phone: business.phone,
      address: getBusinessLocationInfo(business),
      merchantId: business.merchantId,
      status: this.getStatus(business.status),
      createdAt: DateUtils.formatISODate(business.createdAt)
    }));
  }

  openOfferList(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminOfferList',
      data: event,
      width: '700px'
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }
}
